import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader, SellerProfilePage } from "@b2b/ui-components";
import { useAuth } from "../../auth/Authprovider";
import { BizcoverIndiaFigmaHeader } from "../../components/marketing/BizcoverIndiaFigmaHeader";
import { BizcoverIndiaFigmaFooter } from "../../components/marketing/BizcoverIndiaFigmaFooter";

export default function BizcoverIndiaSellerDetailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading, userRole } = useAuth();

  const [searchQuery, setSearchQuery] = useState("");
  const [footerEmail, setFooterEmail] = useState("");

  const handleSearch = () => {
    const q = searchQuery.trim();
    navigate(q ? `/search/${encodeURIComponent(q)}` : "/search");
  };

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f4f6f8]">
        <Loader size={40} color="#f97316" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <div className="min-h-screen bg-[#f4f6f8]">
      <BizcoverIndiaFigmaHeader
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onSearchSubmit={handleSearch}
      />

      <main className="w-full px-4 py-6 lg:px-36">
        <nav className="mb-5 flex flex-wrap items-center gap-2 text-[12px] text-[#919eab] animate-fade-in">
          <Link
            to="/bizcoverindia-home-updated"
            className="transition-colors duration-200 hover:text-[#FF6A00]"
          >
            Home
          </Link>
          <span>/</span>
          <Link
            to="/sellers"
            className="transition-colors duration-200 hover:text-[#FF6A00]"
          >
            Shops
          </Link>
          <span>/</span>
          <span className="text-[#637381]">Shop Profile</span>
        </nav>

        <SellerProfilePage
          embedded
          userRole={userRole}
          showChatForAuthenticated={isAuthenticated}
          companyTabLabel="About"
        />
      </main>

      <BizcoverIndiaFigmaFooter
        email={footerEmail}
        onEmailChange={setFooterEmail}
        onSubscribe={() => {}}
      />
    </div>
  );
}
